import { Injectable, inject } from '@angular/core';
import Browser from '../utils/browser.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';
import AngularMaterialHelperService from '../services/angular-material-helper.service';
import $ from 'jquery';
import { ModalConfirmationComponent } from '../components/modal-confirmation/modal-confirmation.component';
import { Overlay } from '@angular/cdk/overlay';

@Injectable({ providedIn: 'root' })
export default class DialogServices {
	private browser: Browser = inject(Browser);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularMaterialHelperService: AngularMaterialHelperService = inject(AngularMaterialHelperService);
	
	constructor(private overlay: Overlay) {
		
	}
	
	handleDialogShowing() {
		var scrollbarWidth: any = this.browser.getScrollbarWidth();
		$('body').css({	paddingRight: scrollbarWidth + 'px' });
	}
	
	handleDialogComplete(callback) {
		$(".c-modal").scrollTop(0);
		$('body').addClass('md-dialog-is-showing-1');
		if (typeof callback === 'function') callback();
	}
	
	handleDialogRemoving(callback) {
		var dialogCount: any = $('.md-dialog-container').length;
		if (dialogCount <= 1) {
			$('body').css({ paddingRight: '' });
			$('body').removeClass('md-dialog-is-showing-1');
		}
		if (typeof callback === 'function') callback();
	}
	
	confirmation(opts) {
		var options: any = {
			width: '400px',
			height : 'auto',
			controller: ModalConfirmationComponent,
			disableScroll: true,
			disableClose: true,
			scrollStrategy: this.overlay.scrollStrategies.block(),
			data: {
				title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
				submitText: this.angularFilterHelperService.translate('Common.Yes'),
				cancelText: this.angularFilterHelperService.translate('Common.No'),
				isHtmlContent: false,
				bindings: opts.bindings || {},
			}
		};
		Object.keys(opts).forEach((key) => {
			options.data[key] = opts[key];
		});
		var dialog = this.angularMaterialHelperService.getMaterialDialog().open(options.controller, options);
		this.forceScrollBlock(dialog);
		return dialog;
	}
	
	show(opts) {
		var options: any = {
			width: opts.width ? opts.width : '400px',
			height : 'auto',
			data: {
				parent: this.angularHelperService.element(document.body),
				onShowing: this.handleDialogShowing,
				onComplete: () => { this.handleDialogComplete(opts.onComplete); },
				onRemoving: () => { this.handleDialogRemoving(opts.onRemoving); },
			},
			disableClose: true,
			disableScroll: true,
			scrollStrategy: this.overlay.scrollStrategies.block(),
			multiple: false
		};
		Object.keys(opts).forEach((key) => {
			options.data[key] = opts[key];
		});
		var dialog = this.angularMaterialHelperService.getMaterialDialog().open(opts.controller, options);
		this.forceScrollBlock(dialog);
		return dialog;
	}
	
	forceScrollBlock(dialog) {
		// needed because of dialog wierd behaviour that does not add scrollblock class if no active scrollbar
		// this results in some cases 2 visible scrollbars
		var rootHtml = document.getElementsByTagName('html')[0]; 
		if (!rootHtml.className.includes('cdk-global-scrollblock')) {
			rootHtml.className += ' cdk-global-scrollblock';
		}
		dialog.afterClosed().subscribe(
			() => {
				var rootHtmlReloaded = document.getElementsByTagName('html')[0];
				rootHtmlReloaded.className = rootHtmlReloaded.className.replace('cdk-global-scrollblock', '');
			},
			() => {
				var rootHtmlReloaded = document.getElementsByTagName('html')[0];
				rootHtmlReloaded.className = rootHtmlReloaded.className.replace('cdk-global-scrollblock', '');
			}
		);
	}
	
}